<template>
  <div>
    <div v-if="items.length > 0">
      <b-table 
        :hover="hover" 
        :striped="striped" 
        :bordered="bordered" 
        :small="small" 
        :fixed="fixed" 
        responsive="sm" 
        :items="items" 
        :fields="fields" 
        :current-page="currentPage" 
        :per-page="perPage">
        <template slot="options" slot-scope="data">
          <b-dropdown variant="link" size="sm">
            <template slot="button-content">
              Opciones
              <!-- <i class="fa fa-list-ul" no-caret></i><span class="sr-only"></span> -->
            </template>
            <b-dropdown-item v-for="option in options" :key="option.icon"
              @click="$emit(option.function,data.item._id)">
              <i :class="option.icon"></i>  {{ option.label }}
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <nav>
        <b-pagination 
          :total-rows="items.length" 
          :per-page="perPage" 
          v-model="currentPage" 
          prev-text="Ant." 
          next-text="Sig." 
          hide-goto-end-buttons/>
      </nav>
    </div>
    <div v-else><i>No se encontraron registros</i></div>
  </div>
</template>

<script>

export default {
  name: 'c-table',
  props: {
    caption: { type: String, default: 'Table' },
    hover: { type: Boolean, default: true },
    striped: { type: Boolean, default: true},
    bordered: { type: Boolean, default: true },
    small: { type: Boolean, default: true },
    fixed: { type: Boolean, default: false },
    fields: { type: Array, default: null },
    items: { type: Array, default: null },
    options: { type: Array, default: null }
  },
  data: () => {
    return {
      currentPage: 1,
      perPage: 30,
      totalRows: 0
    }
  }
}
</script>
